module.exports = __webpack_public_path__ + "static/img/money-07.1c71dc6.png";